<template>
  <spinner-container :loading="loading">
    <back-btn />
    <v-row justify="center">
      <v-col cols="12" md="6">
        <township-gp-form
          :townshipGroup="townshipGroup"
          @emitTownshipGroupData="updateTownshipGroup"
        />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import TownshipGpForm from "@/components/township-group/TownshipGpForm";
import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";
import SpinnerContainer from "@/components/container/SpinnerContainer.vue";

export default {
  components: {
    TownshipGpForm,
    BackBtn,
    SpinnerContainer,
  },
  data: () => ({}),
  computed: {
    ...mapState("TownshipGroup", ["townshipGroup"]),
    ...mapState("Loading", ["loading"]),
  },
  methods: {
    updateTownshipGroup(payload) {
      this.$store
        .dispatch("TownshipGroup/updateTownshipGroup", payload)
        .then(() => {
          this.$router.push({ name: "township-group" });
        });
    },
  },
  created() {
    this.$store.dispatch("TownshipGroup/getTownshipGroup",this.$route.params.id)
  },
};
</script>
